import { render, staticRenderFns } from "./calcSD2-2.vue?vue&type=template&id=3add09e0&scoped=true"
import script from "./calcSD2-2.vue?vue&type=script&lang=js"
export * from "./calcSD2-2.vue?vue&type=script&lang=js"
import style0 from "./calcSD2-2.vue?vue&type=style&index=0&id=3add09e0&prod&lang=scss"
import style1 from "./calcSD2-2.vue?vue&type=style&index=1&id=3add09e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add09e0",
  null
  
)

export default component.exports